import styled from "styled-components";

import { colors } from "const/colors";
import { facebookLink } from "const/links";

const Link = styled.a`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	color: ${colors.muted};
	font-size: 18px;

	&:hover {
		color: #1877f2;
	}
`;

export default function FacebookLink({ children = "Facebook" }) {
	return (
		<Link href={facebookLink} target="_blank" rel="noopener noreferrer">
			<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
				<path
					fill="currentColor"
					d="M22 12.07C22 6.5 17.52 2 12 2S2 6.5 2 12.07C2 17.1 5.66 21.24 10.44 22v-7.03H7.9v-2.9h2.54V9.41c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.9h-2.34V22C18.34 21.24 22 17.1 22 12.07z"
				/>
			</svg>
			{children}
		</Link>
	);
}
